import React from "react";
import ResultCollection from "./index";

function ResultCollectionContainer() {
  return <ResultCollection />;
}

export default ResultCollectionContainer;



// WEBPACK FOOTER //
// ./src/pages/Admin/ResultCollection/container.js